import GetAllResourceEntriesInteractor from "../../core/interactor/app/crud/GetResourceEntriesInteractor";
import { IIndexHarmonizationReportItem } from "../model/IndexHarmonizationReportItem";
import IndexHarmonizationReportMapper from "../service/IndexHarmonizationReportMapper";

export default class GetIndexesByCategoryIndexDataInteractor {
  private resource: GetAllResourceEntriesInteractor<IIndexHarmonizationReportItem>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute(organisationId: number, organisationIndexCategoryId: number) {
    return this.resource.execute(
      `reports/indexes-by-category`,
      IndexHarmonizationReportMapper,
      () => {},
      {
        form: true,
        params: {
          organisationId,
          organisationIndexCategoryId
        }
      }
    );
  }
}
